module.exports = __webpack_public_path__ + "media/images/eng-2ed83b79c739a492c58734f3c26bc35e.jpg";